export default {
  category: 'book',
  name: 'Letters to a Young Poet',
  author: 'Rainer Maria Rilke',
  date: '5/7/25',
  path: '/notes/letters-to-a-young-poet',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-letters-to-a-young-poet-rainer-maria-rilke.jpg',
  tags: ['Fiction', 'Poetry'],
  time: 19,
  rating: 6.8,
  review: '',
  link: 'https://www.amazon.com/Letters-Young-Rainer-Maria-Rilke/dp/0393310396',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.TwosApp.com/680b111134e1d189fbe51a3d',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
